export default function HeroContent({ data }) {
  return (
    <>
      <h1 className="text-4xl font-bold text-emerald-100 mb-4">
        {data.name}
      </h1>
      
      <p className="text-xl text-emerald-200/90 mb-6 max-w-lg mx-auto">
        {data.title}
      </p>
      
      <p className="text-lg text-gray-300/80 mb-6 max-w-lg mx-auto">
        {data.quote}
      </p>
    </>
  );
}